<template>
  <footer class="footer">
    <div class="container footer-top">
      <div class="row">
        <div class="col-sm-6 col-xl-4 footer-top-contact">
          <h3>Contact Us</h3>
          <ul>
            <li>
              <p class="footer-top-contact-phone">
                T:&nbsp;<a href="tel:07842819256">07842 819256</a>
              </p>
            </li>
            <li>
              <p class="footer-top-contact-email">
                E:&nbsp;<a href="mailto:enquiries@ashfieldbrickwork.co.uk">enquiries@ashfieldbrickwork.co.uk</a>
              </p>
            </li>
          </ul>
        </div>
        <div class="col-sm-6 col-xl-4 mt-4 mt-sm-0 footer-top-navigation">
          <h3>Navigation</h3>
          <ul>
            <li>
              <router-link class="footer-top-navigation-link" to="/portfolio/">
                Portfolio
              </router-link>
            </li>
            <li>
              <router-link class="footer-top-navigation-link" to="/our-services/">
                Our Services
              </router-link>
            </li>
            <li>
              <router-link class="footer-top-navigation-link" to="/testimonials/">
                Testimonials
              </router-link>
            </li>
            <li>
              <router-link class="footer-top-navigation-link" to="/contact-us/">
                Contact Us
              </router-link>
            </li>
          </ul>
        </div>
        <!--<div class="col-sm-6 col-xl-3 mt-4 mt-xl-0 footer-top-legal">
          <h3>Legal</h3>
          <ul>
            <li>
              <router-link class="footer-top-navigation-link" to="/terms-of-use/">
                Terms Of Use
              </router-link>
            </li>
          </ul>
        </div>-->
        <div class="col-sm-6 col-xl-4 mt-4 mt-xl-0 footer-top-social">
          <h3>Follow Us On:</h3>
            <a target="_blank" class="footer-top-social-facebook" rel="noopener noreferer" href="https://www.facebook.com/profile.php?id=61578637665039">
              <img src="~@/assets/images/icon-facebook.svg" alt="facebook">
            </a>
            <a target="_blank" class="footer-top-social-instagram" rel="noopener noreferer" href="https://www.instagram.com/ashfieldbrickwork/">
              <img src="~@/assets/images/icon-instagram.svg" alt="instagram">
            </a>
        </div>
      </div>
    </div>
    <div class="container-fluid footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <p class="footer-bottom-copyright">
              Copyright &copy; Ashfield Brickwork {{ copyrightDate }}. All
              Rights Reserved.
            </p>
          </div>
          <div class="col-lg-6">
            <p class="footer-bottom-nm-link">
              <a href="https://www.netmatters.co.uk" target="_blank" rel="noreferrer">Website Designed</a>&nbsp;by&nbsp;<a
                href="https://www.netmatters.co.uk" target="_blank" rel="noreferrer">Netmatters</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      name: 'main-footer',
      copyrightDate: ''
    }
  },
  mounted() {
    this.copyrightDate = new Date().getFullYear()
  }
}
</script>

<style lang="scss">
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.footer {
  p {
    margin: 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  h3 {
    font-weight: bold;
    font-size: 22px;
    margin-bottom: 1rem;
    width: 100%;
    max-height: 26.39px;
  }

  &-top {
    padding-top: 38px;
    padding-bottom: 38px;

    a {
      font-size: 14px;
      color: $body-text;
    }

    &-contact {
      a {
        font-size: 16px;
      }
    }

    &-social {
      display: flex;
      flex-wrap: wrap;
      align-content: start;

      &-facebook {
        display: inline;
        width: 30px;
        height: 33px;

        &:hover {
          img {
            fill: $primary;
          }
        }

        img {
          width: 100%;
          height: 100%;
        }
      }

      &-instagram {
        display: inline;
        width: 28.48px;
        height: 28.5px;

        &:hover {
          img {
            fill: $primary;
          }
        }

        img {
          margin-top: 3px;
          margin-left: 4px;
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  &-bottom {
    background-color: $secondary-light;
    padding-top: 15px;
    padding-bottom: 15px;

    &-copyright {
      color: $white;
      font-size: 13px;

      @media (max-width: $lg-breakpoint) {
        text-align: center;
      }
    }

    &-nm-link {
      font-size: 13px;
      text-align: right;
      color: #a1a1a3;

      @media (max-width: $lg-breakpoint) {
        text-align: center;
      }

      a {
        text-decoration: underline;
        color: #a1a1a3 !important;

        &:hover {
          color: $white !important;
        }
      }
    }
  }

  .footer-top-licence-number {
    margin-top: 10px;

    span {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue